import moment from 'moment'


const LOW_SUBSCRIPTION_DATE     = 6
const LOW_SUBSCRIPTION_DATE_1ST = 2
const TOP_SUBSCRIPTION_DATE     = 20
const TOP_SUBSCRIPTION_DATE_1ST = 16

type ShippingText = 'mid-month' | 'by end of month'


export default (newDate: Date, isBillingDay1stEnabled: boolean): ShippingText => {
  const date        = moment(newDate).utc()
  const lowerDate   = date.clone().date(isBillingDay1stEnabled ? LOW_SUBSCRIPTION_DATE_1ST : LOW_SUBSCRIPTION_DATE)
  const topDate     = date.clone().date(isBillingDay1stEnabled ? TOP_SUBSCRIPTION_DATE_1ST : TOP_SUBSCRIPTION_DATE)

  // TODO add i18n
  let shippingText: ShippingText = 'mid-month'

  if (date.isBetween(lowerDate, topDate, 'day', '[]')) {
    shippingText = 'by end of month'
  }

  return shippingText
}
